import * as moment from "moment";
import { Model } from "./model";

export class DateInvioAtto extends Model {
  static apiUrl: string = "date_invio_atto";

  incarico_id: number;
  valore: moment.Moment | null;

  deserialize(input: any): DateInvioAtto {
    const result = super.deserialize(input) as DateInvioAtto;

    if (input?.valore) {
      result.valore = moment(input.valore);
    } else {
      result.valore = null;
    }

    return result;
  }
}
